import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import FirstKv from './components/FirstKv';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';

const PageConPc = dynamic(() => import('@/components/Community/indexDynamic'), {
    ssr: true,
});
export default function CommunityPc() {
    if (typeof window !== 'undefined') {
        window.AniContainer = new EfScrollAni();
    }

    useEffect(() => {
        return () => {
            AniContainer.destroy();
        };
    }, []);

    return (
        <div className={`community-pc ${css.communityPc}`}>
            <FirstKv />
            <PageConPc />
        </div>
    );
}
